import { render, staticRenderFns } from "./OngelezenBerichten.vue?vue&type=template&id=4f77eda9&"
import script from "./OngelezenBerichten.vue?vue&type=script&lang=js&"
export * from "./OngelezenBerichten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports